import type { SVGProps } from 'react'
const SvgGreenTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.28215 14.0126L15.275 7.99309L13.7834 6.4749L9.25552 11.0028L6.99155 8.73887L5.5 10.2304L9.28215 14.0126ZM10 19.9999C8.61667 19.9999 7.31667 19.7374 6.1 19.2124C4.88333 18.6874 3.825 17.9749 2.925 17.0749C2.025 16.1749 1.3125 15.1166 0.7875 13.8999C0.2625 12.6832 0 11.3832 0 9.9999C0 8.61657 0.2625 7.31657 0.7875 6.0999C1.3125 4.88324 2.025 3.8249 2.925 2.9249C3.825 2.0249 4.88333 1.3124 6.1 0.787402C7.31667 0.262402 8.61667 -9.76324e-05 10 -9.76324e-05C11.3833 -9.76324e-05 12.6833 0.262402 13.9 0.787402C15.1167 1.3124 16.175 2.0249 17.075 2.9249C17.975 3.8249 18.6875 4.88324 19.2125 6.0999C19.7375 7.31657 20 8.61657 20 9.9999C20 11.3832 19.7375 12.6832 19.2125 13.8999C18.6875 15.1166 17.975 16.1749 17.075 17.0749C16.175 17.9749 15.1167 18.6874 13.9 19.2124C12.6833 19.7374 11.3833 19.9999 10 19.9999ZM10 17.9999C12.2333 17.9999 14.125 17.2249 15.675 15.6749C17.225 14.1249 18 12.2332 18 9.9999C18 7.76657 17.225 5.8749 15.675 4.3249C14.125 2.7749 12.2333 1.9999 10 1.9999C7.76667 1.9999 5.875 2.7749 4.325 4.3249C2.775 5.8749 2 7.76657 2 9.9999C2 12.2332 2.775 14.1249 4.325 15.6749C5.875 17.2249 7.76667 17.9999 10 17.9999Z"
      fill="#4E8842"
    />
  </svg>
)
export default SvgGreenTick
